import { EventBus } from '../../../../core/shared/helpers/EventHelper';
import ItemComponent from '../../../../core/infraestructure/ItemComponent';
import EvaluationViewModel from '../../../../core/features/evaluations/viewmodels/EvaluationViewModel';

export default {
    extends: ItemComponent,
    data() {
        return {
            modulePermissions: 'ReviewsContent-Reviews',
            courses: [],
            students: [],
            viewModel: null,
            permissions: null,
            modules: [],
            rules: {
                qualification: [
                    { required: true, message: 'Calificación requerida.', trigger: 'blur' }
                ],
            }
        }
    },
    props: {
        conf: {
            type: Object,
            required: true
        },
        formData: {
            type: Object,
            required: true
        }
    },
    created() {
        this.viewModel = new EvaluationViewModel(this)
        this.onActive()
    },
    mounted() { },
    methods: {
        onActive() { },
        onSubmitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // Este modal es el de "evaluar el curso en curso": no pide
                    // estudiante ni curso (los resuelve el backend con el usuario
                    // autenticado y el curso abierto), por lo que NO debe usar el
                    // guardado administrativo. Se delega al padre, que llama a
                    // POST api/evaluations/do-course-evaluation.
                    EventBus.$emit('onSubmitedEvaluation', this.formData);
                }
            });
        },
        onCanSaveOrUpdate() {
            return this.canCreate(this.modulePermissions) || this.canUpdate(this.modulePermissions)
        },
        onSaveResponse(response) {
            this.showLoading(false, '');
            this.onShowSuccess(response.message);
            this.showComponent(false);
        }
    }
}